export const FORM_ACTIONS = {
  TOGGLE_FORM_DATA: 'toggle',
  UPDATE_FORM_FIELD: 'update',
  ADD_NEW_MEDICATION: 'add-new-medication',
  REMOVE_MEDICATION: 'remove-medication',
  INIT_AFFILIATE: 'init-affiliate',
};
